import CalendarIcon from '@ps-design-system/icons/Calendar/Calendar24';
import GroupIcon from '@ps-design-system/icons/Group/Group24';
import MapPinIcon from '@ps-design-system/icons/MapPin/MapPin24';
import TimeIcon from '@ps-design-system/icons/Time/Time24';
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { withBookingDetails } from './with-booking-details';

export const CateringBookingDetailsBar = withBookingDetails(
  ({ displayDate, displayTime, displayLocation, displayAttendees }) => {
    const [isStuck, setIsStuck] = useState(false);
    const stickyRef = useRef(null);

    useEffect(() => {
      const handleScroll = () => {
        const stickyElement = stickyRef.current;
        const isSticky = stickyElement.getBoundingClientRect().top <= 72;
        setIsStuck(isSticky);
      };

      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
      <div
        ref={stickyRef}
        className={classnames('catering-booking-details-desktop', {
          'is-stuck': isStuck
        })}
      >
        <div className="ps-container-lg-margin ps-container-fixed border catering-booking-details-bar-wrap">
          <div className="ps-row">
            <div className="col-xs-12 catering-booking-details-bar-inner">
              <p className="tw-headline-1-m no-margin">About your booking</p>
              <div className="catering-booking-detail-item">
                <CalendarIcon style={{ minWidth: '24px' }} />
                <span className="tw-body-2">{displayDate}</span>
              </div>
              <div className="catering-booking-detail-item">
                <TimeIcon style={{ minWidth: '24px' }} />
                <span className="tw-body-2">{displayTime}</span>
              </div>
              <div className="catering-booking-detail-item">
                <MapPinIcon style={{ minWidth: '24px' }} />
                <span className="tw-body-2">{displayLocation}</span>
              </div>
              <div className="catering-booking-detail-item">
                <GroupIcon style={{ minWidth: '24px' }} />
                <span className="tw-body-2">{displayAttendees}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);
